import {
  useExternalCalendarConnections,
  useTwoWaySyncAllowed,
} from 'features/external-connections';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ConnectCalendarCard as ConnectCalendarCardUI } from 'shared/components/ui/connect-calendar-card';
import { useOpenSettings } from 'shared/contexts/user-settings';
import { SettingsSection } from 'shared/dialogs/user-settings/settings-nav';
import { useDismissibleStorage } from 'shared/hooks/use-dismissible-storage';
import { useUser } from 'shared/hooks/use-user';

const STORAGE_KEY_PREFIX = 'griply.connect-calendar-card.';

export const ConnectCalendarCard: React.FC = () => {
  const { t } = useTranslation();
  const user = useUser();
  const openSettings = useOpenSettings();
  const connections = useExternalCalendarConnections();
  const { allowed: twoWaySyncAllowed } = useTwoWaySyncAllowed();
  const { dismissed, dismiss } = useDismissibleStorage(
    `${STORAGE_KEY_PREFIX}${user?.uid ?? ''}`,
  );

  const onConnect = useCallback(
    () => openSettings(SettingsSection.Calendar),
    [openSettings],
  );

  if (connections.length || dismissed) {
    return null;
  }

  const subtitleKey = twoWaySyncAllowed
    ? 'today.calendar-connect-card.subtitle.premium'
    : 'today.calendar-connect-card.subtitle.free';

  return (
    <ConnectCalendarCardUI
      title={t('today.calendar-connect-card.title')}
      subtitle={t(subtitleKey)}
      connectLabel={t('today.calendar-connect-card.connect')}
      dismissLabel={t('today.calendar-connect-card.dismiss')}
      onConnect={onConnect}
      onDismiss={dismiss}
    />
  );
};
